if (!customElements.get('toz-slider-price-range')) {
class TOZSliderPriceRange extends HTMLElement {
	constructor() {
		super();

		// get initial values
		let minValue = this.getAttribute('data-min-range');
		let maxValue = this.getAttribute('data-max-range');;

		let selectedMin = this.getAttribute('data-min-selected') || minValue;
		let selectedMax = this.getAttribute('data-max-selected') || maxValue;


		const rangeInputMin = this.querySelector('input[type=number][data-value-min]');
		const rangeInputMax = this.querySelector('input[type=number][data-value-max]');

		rangeInputMin.min = minValue;
		rangeInputMin.max = maxValue;
		rangeInputMin.value = selectedMin;

		rangeInputMax.min = minValue;
		rangeInputMax.max = maxValue;
		rangeInputMax.value = selectedMax;

		const noSteps = 5;
		const sliderSteps = this.querySelector('.slider-numbers');


		for (let i = 0; i < noSteps; i++) {
			let step = Math.round((parseInt(maxValue) - parseInt(minValue)) * ((1 / noSteps) * i) + parseInt(minValue));
			let stepElem = document.createElement('span');
			stepElem.innerHTML = step;
			sliderSteps.appendChild(stepElem);
		}

		let stepElem = document.createElement('span');
		stepElem.innerHTML = Math.round(parseInt(maxValue));
		sliderSteps.appendChild(stepElem);

		let sliderInputMin = this.querySelector('[data-slider-min]')
		let sliderInputMax = this.querySelector('[data-slider-max]')

		sliderInputMin.min = minValue;
		sliderInputMin.max = maxValue;
		sliderInputMin.value = selectedMin;

		sliderInputMax.min = minValue;
		sliderInputMax.max = maxValue;
		sliderInputMax.value = selectedMax;

		if (rangeInputMin.min == selectedMin && rangeInputMax.max == selectedMax) {
			rangeInputMin.dataset.active = "false"
			rangeInputMax.dataset.active = "false"
			sliderInputMin.dataset.active = "false"
			sliderInputMax.dataset.active = "false"
		} else {
			rangeInputMin.dataset.active = "true"
			rangeInputMax.dataset.active = "true"
			sliderInputMin.dataset.active = "true"
			sliderInputMax.dataset.active = "true"
		}


		this.sliderMin = this.querySelector('[data-slider-min]');
		this.sliderMax = this.querySelector('[data-slider-max]');

		this.minValueField = this.querySelector('input[type=number][data-value-min]');
		this.maxValueField = this.querySelector('input[type=number][data-value-max]');
		this.minGap = 5;
		this.sliderTrack = this.querySelector(".slider-track");
		this.sliderMaxValue = this.sliderMax.max;
		this.sliderMinValue = this.sliderMin.min;

		this.querySelectorAll('input[type="number"]')
			.forEach(element => element.addEventListener('change', this.setMinAndMaxValues.bind(this)));

		this.querySelectorAll('input[type="range"]')
			.forEach(element => element.addEventListener('input', this.setMinAndMaxSliderValues.bind(this)));

		this.querySelectorAll('input')
			.forEach(element => element.addEventListener('input', this.setActive.bind(this)));

		this.setMinAndMaxValues();
		this.setMinAndMaxSliderValues();

		this.fillColor();
	}

	setActive() {
		if (this.minValueField.value == this.minValueField.min && this.maxValueField.value == this.maxValueField.max) {
			this.minValueField.dataset.active = "false";
			this.maxValueField.dataset.active = "false";
		} else {
			this.minValueField.dataset.active = "true";
			this.maxValueField.dataset.active = "true";
		}

		if (this.sliderMin.value == this.sliderMin.min && this.sliderMax.value == this.sliderMax.max) {
			this.sliderMin.dataset.active = "false";
			this.sliderMax.dataset.active = "false";
		} else {
			this.sliderMin.dataset.active = "true";
			this.sliderMax.dataset.active = "true";
		}

	}

	setMinAndMaxSliderValues() {


		if (parseInt(this.sliderMin.value) > parseInt(this.sliderMax.value)) {
			this.sliderMin.value = this.sliderMax.value - this.minGap;
		}

		else if (parseInt(this.sliderMax.value) - parseInt(this.sliderMin.value) <= this.minGap) {
			this.sliderMin.value = parseInt(this.sliderMax.value) - this.minGap;
		}
		this.minValueField.value = this.sliderMin.value;
		this.maxValueField.value = this.sliderMax.value;


		this.fillColor();

	}

	setMinAndMaxValues() {


		if (parseInt(this.minValueField.value) > parseInt(this.maxValueField.value)) {
			this.minValueField.value = this.maxValueField.value - this.minGap;
		}
		else if (parseInt(this.maxValueField.value) - parseInt(this.minValueField.value) <= this.minGap) {
			this.minValueField.value = parseInt(this.maxValueField.value) - this.minGap;
		}
		this.sliderMin.value = this.minValueField.value;
		this.sliderMax.value = this.maxValueField.value;

		this.fillColor();
	}

	fillColor() {
		var percent1 = ((this.sliderMin.value - this.sliderMinValue) / (this.sliderMaxValue - this.sliderMinValue)) * 100;
		var percent2 = ((this.sliderMax.value - this.sliderMinValue) / (this.sliderMaxValue - this.sliderMinValue)) * 100;
		this.sliderTrack.style.background = `linear-gradient(to right, #DFF1F0 ${percent1}% , #216155 ${percent1}% , #216155 ${percent2}%, #DFF1F0 ${percent2}%)`;
	}
}

customElements.define('toz-slider-price-range', TOZSliderPriceRange);
}


if (!customElements.get('toz-facet-color')) {
class TOZFacetColor extends HTMLElement {
	constructor() {
		super();

		this.color = this.getAttribute('color');

		this.setColor();
	}

	setColor(){
		if (this.color.includes('#')) {
			this.style.background = this.color;
		}
		else if (this.color.includes(".png")) {
			//const imageSrc = document.body.dataset.cdnPath.concat(this.color);
			this.style.backgroundImage = `url('${this.color}')`;
		}
	}
}

customElements.define('toz-facet-color', TOZFacetColor);
}

